import { styled, css } from '$utils/theme'
import { rem } from 'polished'

interface Props {
  wide?: boolean
  nursingHome?: boolean
  noTop?: boolean
  noBottom?: boolean
}
export const Container = styled.div.attrs({})<Props>`
  ${p =>
    p.wide &&
    css`
      max-width: ${rem(p.theme.grid.contentMaxWidth.wide)};
    `};
  ${p =>
    !p.wide &&
    css`
      max-width: ${p.theme.media.desktop
        ? rem(p.theme.grid.contentMaxWidth.desktop)
        : rem(p.theme.grid.contentMaxWidth.mobile)};
    `};

  padding: ${p => rem(p.theme.sizes.small)} ${p => rem(p.theme.sizes.mini)};

  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${p => (p.noBottom ? 0 : rem(p.theme.sizes.small))};

  position: relative;

  top: ${p => (p.noTop ? '0rem' : '3rem')};
  ${p => !p.nursingHome && p.theme.media.desktop`top:${p.noTop ? '0rem' : '4.5rem'}`};
  ${p =>
    p.nursingHome &&
    css`
      top: 6.5rem;

      ${p.theme.media.desktop`
        top: 9rem;
      `}
    `};

  width: 100%;
`



// WEBPACK FOOTER //
// ./src/views/components/Layout/Container/Container.tsx